import Phaser from "phaser";
import { RUN_HUD_SCENE_KEY } from "./RunHudScene";
import { getAutomationOverride } from "../automation/automationTags";
import { ENCOUNTER_SCENE_KEY } from "./EncounterScene";
import { StartScreen } from "./MainMenuScene/screens/StartScreen";
import { CharacterSelectScreen } from "./MainMenuScene/screens/CharacterSelectScreen";
import type { Screen } from "../screens/types";

export const MAIN_MENU_SCENE_KEY = "MAIN_MENU";

export class MainMenuScene extends Phaser.Scene {
  private currentScreen?: Screen;
  private uiContainer!: Phaser.GameObjects.Container;

  constructor() {
    super(MAIN_MENU_SCENE_KEY);
  }

  create() {
    // Main menu must not show the HUD.
    if (this.scene.isActive(RUN_HUD_SCENE_KEY)) {
      this.scene.stop(RUN_HUD_SCENE_KEY);
    }

    // If debug combat is requested, jump straight into encounter mode.
    // (EncounterScene will re-launch the HUD as needed.)
    const params = new URLSearchParams(window.location.search);
    const debugFlag =
      params.get("debugCombat") ?? params.get("debug") ?? getAutomationOverride("combat");
    if (debugFlag) {
      const normalized = String(debugFlag).toLowerCase();
      if (normalized === "combat" || normalized === "1" || normalized === "true") {
        this.scene.start(ENCOUNTER_SCENE_KEY);
        return;
      }
    }

    // Create UI container for screens
    this.uiContainer = this.add.container(0, 0);

    // Show initial start screen
    this.showStartScreen();
  }

  showStartScreen() {
    this.setScreen(new StartScreen(this));
  }

  showCharacterSelect() {
    this.setScreen(new CharacterSelectScreen(this));
  }

  private setScreen(screen: Screen) {
    // Exit current screen
    if (this.currentScreen) {
      this.currentScreen.exit();
    }

    // Set new screen
    this.currentScreen = screen;
    this.uiContainer.add(screen.container);
    screen.enter();
  }
}
